import React, { Dispatch, SetStateAction, useContext, useEffect, useRef } from 'react'
import { Button, Card, Col, Row, Space, Switch, Typography } from "antd";
import { Formik } from 'formik';
import { CSUserProfile } from '../../../models/csuser-profile-interface';
import UserForm from '../forms/UserForm';
import { AuthContext } from '../../../utilites/auth';
import { UserRole } from '../../../models/user-role-interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-regular-svg-icons';

const { Title } = Typography

type Props = {
  selectedUser: CSUserProfile;
  roles: UserRole[];
  formRef: React.MutableRefObject<any>;
  setIsSubmitting: Dispatch<SetStateAction<boolean>>;
  allUsers: CSUserProfile[];
}

const EditUserCard: React.FC<Props> = ({
  selectedUser,
  roles,
  formRef,
  setIsSubmitting,
  allUsers
}) => {
  const { profile } = useContext(AuthContext);
  
  useEffect(() => {
    formRef?.current?.resetForm();
  }, [selectedUser])

  return <div style={{width: '100%'}}>
    <UserForm
      formRef={formRef}
      selectedUser={selectedUser}
      profile={profile}
      roles={roles}
      setIsSubmitting={setIsSubmitting}
      allUsers={allUsers}
    />
  </div>
}

export default EditUserCard;